import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt="FyreBooking" title="FyreBooking" src="/cal-com-icon.svg" />
        ) : (
          <>
            <img
              className={classNames(small ? "h-8 w-auto" : "h-12 w-auto", "dark:hidden")}
              alt="FyreBooking"
              title="FyreBooking"
              src="/cal-logo-word-black.svg"
            />
            <img
              className={classNames(small ? "h-8 w-auto" : "h-12 w-auto", "hidden dark:block")}
              alt="FyreBooking"
              title="FyreBooking"
              src="/calcom-logo-white-word.svg"
            />
          </>
        )}
      </strong>
    </h3>
  );
}
